import { LogIn } from "./elements/account/Login";
import { Register } from "./elements/account/Register";
import "./elements/cart/AddToCart";
import { ContinueShopping } from "./elements/cart/CountinueShopping";
import { RemoveFromCart } from "./elements/cart/RemoveFromCart";
import { ApplyGiftCard } from "./elements/checkout/ApplyGiftCard";
import "./elements/checkout/BillingAddressCheckbox";
import "./elements/checkout/Checkout";
import { implementTablist } from "./elements/checkout/CheckoutTabs";
import { CompanyCheckbox } from "./elements/checkout/CompanyNameCheckbox";
import { ContinueToPayment } from "./elements/checkout/ContinueToPayment";
import { DeliveryOptionPicker } from "./elements/checkout/DeliveryOptionPicker";
import { EditCheckoutStep } from "./elements/checkout/EditCheckoutStep";
import { GiftCardCheckbox } from "./elements/checkout/GiftCardCheckbox";
import { ReviewOrderButton } from "./elements/checkout/ReviewOrderButton";
import { ContinueAsGuest } from "./elements/ContinueAsGuest";
import { ApplyCoupon } from "./elements/coupons/ApplyCoupon";
import { CouponCheckbox } from "./elements/coupons/CouponCheckbox";
import { RemoveCoupon } from "./elements/coupons/RemoveCoupon";
import { NewsletterSubscription } from "./elements/NewsletterSubscription";
import "./elements/Quantity";
import { ReadMoreButton } from "./elements/ReadMoreButton";
import { RedirectButton } from "./elements/RedirectButton";
import { SignInCheckout } from "./elements/SignInCheckout";
import "./elements/SnapTabs";
import { SortDropdown } from "./elements/SortDropdown";
import { ViewMoreProducts } from "./elements/ViewMoreProducts";
import { collectionNavigation, headerCustomBehaviour, implementArrowNavigation_gen, myFunction, singleProductPhotosMobileBehaviour, toggleMobileHeader, updateDisplay } from "./utils";

customElements.define("gct-apply-coupon", ApplyCoupon);
customElements.define("gct-apply-gift-card", ApplyGiftCard);
customElements.define("gct-company-name-checkbox", CompanyCheckbox);
customElements.define("gct-continue-as-guest", ContinueAsGuest);
customElements.define("gct-continue-shopping", ContinueShopping);
customElements.define("gct-continue-to-payment", ContinueToPayment);
customElements.define("gct-coupon-checkbox", CouponCheckbox);
customElements.define("gct-delivery-option-picker", DeliveryOptionPicker);
customElements.define("gct-edit-checkout-step", EditCheckoutStep);
customElements.define("gct-gift-card-checkbox", GiftCardCheckbox);
customElements.define("gct-log-in", LogIn);
customElements.define("gct-newsletter-subscription", NewsletterSubscription);
customElements.define("gct-read-more", ReadMoreButton);
customElements.define("gct-redirect-button", RedirectButton);
customElements.define("gct-register", Register);
customElements.define("gct-remove-coupon", RemoveCoupon);
customElements.define("gct-remove-from-cart", RemoveFromCart);
customElements.define("gct-review-order", ReviewOrderButton);
customElements.define("gct-sign-in-checkout", SignInCheckout);
customElements.define("gct-sort-dropdown", SortDropdown);
customElements.define("gct-view-more", ViewMoreProducts);

window.addEventListener("load", () => {
	window.scrollTo(0, 0);

	const tablists = document.querySelectorAll("[role=tablist]");
	tablists.forEach(implementTablist);

	headerCustomBehaviour();
	toggleMobileHeader()

	updateDisplay();

	singleProductPhotosMobileBehaviour();

	collectionNavigation();

	implementArrowNavigation_gen("recommend-container", ".gct-recommend", "carousel-arrow-prev-recommend", "carousel-arrow-next-recommend");
	implementArrowNavigation_gen("christmas-container", ".gct-recommend", "carousel-arrow-prev-christmas", "carousel-arrow-next-christmas");

	myFunction("myDIV", "try-it-button");
	myFunction("myDIV2", "try-it-button2");
	myFunction("myDIV3", "try-it-button3");
	myFunction("myDIV4", "try-it-button4");
	myFunction("myDIV5", "try-it-button5");
	myFunction("myDIV6", "try-it-button-checkout");

	const originalInnerHTML = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML')!.set!;
	Object.defineProperty(document.body, 'innerHTML', {
		set(value) {
			originalInnerHTML.call(this, value);
			updateDisplay();
			window.scrollTo(0, 0);
		},
	});
});
